export default "../fonts/akzidgrtskprobolcnd-webfont.59d64fa08fc10a2841430bb0ec5ba9e2.woff2";